// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { GuidedChangeEventPage_ChangeEventFragmentDoc } from '../../../GuidedChangeEventPage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SwapProduct_SaveChangeEventMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventInput;
}>;


export type SwapProduct_SaveChangeEventMutation = { __typename?: 'Mutation', saveChangeEvent: { __typename?: 'SaveChangeEventResult', changeEvent: { __typename?: 'ChangeEvent', id: string, title: string, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, project:
        | { __typename?: 'StandaloneProject', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Region', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Market', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Community', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Subdivision', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Lot', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Structure', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Unit', id: string, shouldAccrueAsComplete: boolean, name: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType }, stage: { __typename?: 'ProjectStage', id: string }, parentsRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          >, siblingProjects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
      , materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, originalProjectItem: { __typename?: 'ProjectItem', id: string }, proposedMaterialVariant: { __typename?: 'MaterialVariant', id: string } }> } } };


export const SwapProduct_SaveChangeEventDocument = gql`
    mutation SwapProduct_SaveChangeEvent($input: SaveChangeEventInput!) {
  saveChangeEvent(input: $input) {
    changeEvent {
      ...GuidedChangeEventPage_ChangeEvent
    }
  }
}
    ${GuidedChangeEventPage_ChangeEventFragmentDoc}`;

/**
 * __useSwapProduct_SaveChangeEventMutation__
 *
 * To run a mutation, you first call `useSwapProduct_SaveChangeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapProduct_SaveChangeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapProductSaveChangeEventMutation, { data, loading, error }] = useSwapProduct_SaveChangeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwapProduct_SaveChangeEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SwapProduct_SaveChangeEventMutation, SwapProduct_SaveChangeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SwapProduct_SaveChangeEventMutation, SwapProduct_SaveChangeEventMutationVariables>(SwapProduct_SaveChangeEventDocument, options);
      }
export type SwapProduct_SaveChangeEventMutationHookResult = ReturnType<typeof useSwapProduct_SaveChangeEventMutation>;
export type SwapProduct_SaveChangeEventMutationResult = ApolloReactCommon.MutationResult<SwapProduct_SaveChangeEventMutation>;